<script setup lang="ts">
import EntityHeader from './entity-header.vue'
import EntityTabs from './entity-tabs.vue'
import TheLayout from '@/modules/shared/layouts/the-layout.vue'
import { TheContent } from '@/modules/shared/components'
import { useEntityStore } from '@/modules/investing/stores/better-entity-store'
import { useAuthStore } from '@/modules/auth/stores/auth-store'
import type { EntityTab } from './types'

withDefaults(
  defineProps<{
    selectedTab: EntityTab
    skeleton?: boolean
  }>(),
  {
    skeleton: false,
  },
)

const entityStore = useEntityStore()
const authStore = useAuthStore()
</script>

<template>
  <TheLayout>
    <EntityHeader :skeleton="skeleton" :entity="entityStore.entity" :current_user_role="authStore.current_user.role">
      <template #badges>
        <slot name="badges"></slot>
      </template>
      <template #actions>
        <slot name="actions"></slot>
      </template>
      <template #tabs>
        <EntityTabs :selectedTab="selectedTab" variant="dark" />
      </template>
    </EntityHeader>
    <TheContent :disableSideSection="true">
      <template #main>
        <slot></slot>
      </template>
    </TheContent>
  </TheLayout>
</template>
